import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Loader } from 'components/teamsnapUIExtensions';
import { Button } from '@teamsnap/teamsnap-ui';
import { connect } from 'react-redux';
import { hideModal } from 'state/modal/actions';
import { showFeedback } from 'state/feedback/actions';
import { SUCCESS, ERROR } from 'components/teamsnapUIExtensions/Feedback/Feedback';
import styles from './ModalDeleteInvoice.module.scss';

class ModalDeleteInvoice extends PureComponent {
  state = {
    disableButton: false,
  };

  handleClose = () => {
    this.props.hideModal();
  };

  handleConfirm = () => {
    const { handleConfirm } = this.props;

    this.setState({
      disableButton: true,
    });

    const feedbackSuccessProps = {
      title: 'Success!',
      message: 'The invoice has been deleted.',
      type: SUCCESS,
    };

    const feedbackErrorProps = {
      title: 'Oops!',
      // eslint-disable-next-line
      message:
        'Something went wrong on our end. Please try again, and if the error persists let us know at https://helpme.teamsnap.com/?solvvy=true so we can see what\'s going on.',
      type: ERROR,
    };
    handleConfirm(this.props)
      .then(() => this.props.showFeedback(feedbackSuccessProps))
      .catch(() => {
        this.props.showFeedback(feedbackErrorProps);
      })
      .finally(() => this.handleClose());
  };

  render() {
    const { disableButton } = this.state;
    const modalProps = {
      handleClose: this.handleClose,
      className: styles.ModalSmall,
      ...this.props,
    };

    return (
      <Modal { ...modalProps } title={ 'Delete Invoice' } componentStyles={ styles } headerIcon="alert">
        <div className={ styles.ModalBody }>
          { !disableButton && <h5>Warning. This cannot be undone.</h5> }
          { disableButton && <Loader icon="spin" text={ 'Deleting Invoice' } /> }
          { !disableButton && (
            <p>
              If you delete this open invoice you will no longer have access to it. (Cue dramatic music.) Are you sure
              you want to delete?
            </p>
          ) }
        </div>

        <footer className={ styles.ModalFooter }>
          <Button
            color="negative"
            icon="dismiss"
            onClick={ this.handleClose }
            mods="u-spaceRightSm"
            isDisabled={ disableButton }
          >
            Don't Delete
          </Button>
          <Button color="primary" onClick={ this.handleConfirm } isDisabled={ disableButton }>
            Yes, Delete Invoice
          </Button>
        </footer>
      </Modal>
    );
  }
}

ModalDeleteInvoice.propTypes = {
  hideModal: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  showFeedback: PropTypes.func,
};

ModalDeleteInvoice.defaultProps = {
  showFeedback: null,
};

export default connect(null, {
  hideModal,
  showFeedback,
})(ModalDeleteInvoice);
